import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  AppBar,
  Box,
  Grid,
  TypographyProps,
  Toolbar,
  ListItemButton,
  ListItemText,
  ListItem,
  Typography,
  List,
  ListItemAvatar,
  Avatar,
  ListSubheader,
  Chip,
  Rating,
  IconButton,
  Collapse,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import moment from 'moment';
import _ from 'lodash';
import { getTrial, getTrialState } from '../../../store/Trial';
import { useAppSelector } from '../../../hooks';
import DetailViewCard from '../../../components/Card/DetailViewCard';
import CustomGrayContainer from '../../../components/Containers/CustomGrayContainer';
import FullScreenLoader from '../../../components/Loaders/FullScreenloader';
import { getAppName, getShortName } from '../../../helper';
import HomeHeader from '../../Home/components/HomeHeader';

// STYLES
const titleProps: TypographyProps = {
  variant: 'caption',
  className: 'ellipsis-text',
  sx: {
    color: 'text.primary',
  },
};

const descriptionProps: TypographyProps = {
  className: 'ellipsis-text',
  variant: 'subtitle2',
  fontWeight: 600,
  sx: {
    color: 'text.primary',
  },
};

const useStyles = makeStyles({
  label: {
    fontSize: '14px',
    fontWeight: '600',
    textAlign: 'center',
    margin: '0 0 15px 0',
  },
  formGroup: {
    background: '#F6F6F6',
    padding: '15px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '80px',
  },
  tagContainer: {
    margin: '15px 0 0 0',
    width: '100%',
  },
  tag: {
    width: '100%',
    background: '#FFFFFF',
    color: '#A7A7A7',
    fontSize: '14px',
    fontWeight: '500',
    marginTop: '10px',
    borderRadius: '10px',
    padding: '10px',
    textAlign: 'center',
  },
  radioContainer: {
    display: 'flex',
    justifyContent: 'center',
    color: '#000000b3',
    fontSize: '14px',
    margin: '0',
    fontWeight: '500',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  button: {
    fontFamily: 'Roboto',
    fontWeight: '500',
    margin: '0',
  },
});

const TrialClassRecordings: React.FC = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const classes = useStyles();
  const trialState = useAppSelector(getTrialState);

  const [mediaKey, setMediaKey] = React.useState(Math.random());
  const [isListExpanded, setListExpanded] = useState(false);
  const [videos, setVideos] = React.useState([] as string[]);
  const [audios, setAudios] = React.useState([] as string[]);
  const [currentVideo, setCurrentVideo] = React.useState({
    type: '' as string,
    url: '' as string,
  });

  const { trialId } = params;

  useEffect(() => {
    if (trialId) {
      dispatch(getTrial(trialId));
    }
  }, []);

  const trialClass = trialState.list;
  const { status } = trialState;
  const _feedback =
    trialClass &&
    trialClass.tutorFeedback &&
    trialClass.tutorFeedback.isStudentAttended &&
    trialClass.tutorFeedback.isStudentAttended === 'Yes'
      ? trialClass.tutorFeedback
      : undefined;

  const student =
    trialClass &&
    trialClass.consultees &&
    trialClass.consultees.length &&
    trialClass.consultees[0]
      ? trialClass.consultees[0]
      : undefined;
  const tutor =
    trialClass && trialClass.consultant && trialClass.consultant
      ? trialClass.consultant
      : undefined;

  const tutorName = tutor ? getShortName(tutor.firstName, tutor.lastName) : '';
  const studentName = student
    ? getShortName(student.firstName, student.lastName)
    : '';

  useEffect(() => {
    if (
      trialClass &&
      trialClass.zoomRecordings &&
      trialClass.zoomRecordings.length
    ) {
      setCurrentVideo(trialClass.zoomRecordings[0]);
      const filterVideos: string[] = [];
      const filterAudios: string[] = [];
      trialClass.zoomRecordings.forEach((recording) => {
        if (recording.type === 'MP4') {
          filterVideos.push(recording.url);
        } else if (recording.type === 'M4A') {
          filterAudios.push(recording.url);
        }
      });
      setVideos(filterVideos);
      setAudios(filterAudios);
    }
  }, [trialClass]);

  const PLAY_LIST = () => {
    return (
      <List
        sx={{
          height: '100%',
          position: 'relative',
          overflow: 'auto',
        }}
        subheader={
          <ListSubheader
            sx={{
              alignItems: 'center',
              backgroundColor: 'black',
              color: 'white',
              borderRadius: '20px',
              fontSize: '12px',
              display: { lg: 'flex', xs: 'none' },
            }}
          >
            <PlaylistPlayIcon />
            Playlist
          </ListSubheader>
        }
      >
        <ListSubheader
          sx={{
            backgroundColor: '#2f3031',
            color: 'white',
            textAlign: 'center',
            lineHeight: '25px',
            fontSize: '12px',
            marginBottom: '15px',
          }}
        >
          Video Recordings
        </ListSubheader>
        {videos &&
          videos.map((recording, index) => {
            const selectedStyles: React.CSSProperties = {};

            if (currentVideo && currentVideo.url === recording) {
              selectedStyles.backgroundColor = 'rgba(255, 255, 255, 0.3)';
            }

            return (
              <ListItem
                key={index}
                style={{
                  marginBottom: '5px',
                  borderRadius: '4px',
                  ...selectedStyles,
                }}
              >
                <ListItemButton
                  style={{
                    padding: '0',
                  }}
                  onClick={() => {
                    setCurrentVideo({ type: 'MP4', url: recording });
                    setMediaKey(Math.random());
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      variant="square"
                      sx={{
                        height: '64px',
                        width: '90px',
                        borderRadius: '5px',
                      }}
                      src={`${process.env.PUBLIC_URL}/images/thumbnails/video3.png`}
                      alt={`Video ${index + 1} Thumbnail`}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    sx={{
                      color: 'white',
                      paddingLeft: '10px',
                    }}
                    primaryTypographyProps={{ fontSize: '12px' }}
                    primary={`${trialClass.curriculum || ''} ${
                      trialClass.subject || ''
                    } ${trialClass.grade || ''} Class Video Recording ${
                      index + 1
                    }`}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        {!videos.length && (
          <ListItem>
            <ListItemText
              sx={{ color: 'white', fontSize: '12px' }}
              primary="No Video Recordings"
            />
          </ListItem>
        )}
        <ListSubheader
          sx={{
            backgroundColor: '#2f3031',
            color: 'white',
            textAlign: 'center',
            lineHeight: '25px',
            fontSize: '12px',
            marginBottom: '15px',
          }}
        >
          Audio Recordings
        </ListSubheader>
        {audios &&
          audios.map((recording, index) => {
            const selectedStyles: React.CSSProperties = {};

            if (currentVideo && currentVideo.url === recording) {
              selectedStyles.backgroundColor = 'rgba(255, 255, 255, 0.3)';
            }

            return (
              <ListItem
                key={index}
                style={{
                  marginBottom: '15px',
                  borderRadius: '4px',
                  ...selectedStyles,
                }}
              >
                <ListItemButton
                  style={{
                    padding: '0',
                  }}
                  onClick={() => {
                    setCurrentVideo({ type: 'M4A', url: recording });
                    setMediaKey(Math.random());
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      variant="square"
                      sx={{
                        height: '64px',
                        width: '90px',
                        borderRadius: '5px',
                      }}
                      src={`${process.env.PUBLIC_URL}/images/thumbnails/audio3.png`}
                      alt={`Audio ${index + 1} Thumbnail`}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    sx={{
                      color: 'white',
                      fontSize: '12px',
                      paddingLeft: '10px',
                    }}
                    primaryTypographyProps={{ fontSize: '12px' }}
                    primary={`${trialClass.curriculum || ''} ${
                      trialClass.subject || ''
                    } ${trialClass.grade || ''} Class Audio Recording ${
                      index + 1
                    }`}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        {!audios.length && (
          <ListItem>
            <ListItemText
              sx={{ color: 'white', fontSize: '12px' }}
              primary="No Audio Recordings"
            />
          </ListItem>
        )}
      </List>
    );
  };

  if (status === 'loading') {
    return <FullScreenLoader />;
  }
  return (
    <Box
      sx={{
        backgroundImage: {
          xs: 'none',
          md: `url(${process.env.PUBLIC_URL}/images/thumbnails/background3.png)`,
        },
      }}
    >
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <HomeHeader />
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          marginLeft: { xs: '0', sm: '8%' },
          marginRight: { xs: '0', sm: '8%' },
        }}
      >
        <Box
          style={{
            padding: '40px 30px 15px 30px',
          }}
          sx={{
            display: { lg: 'block', xs: 'none' },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Student Name"
                titleProps={titleProps}
                description={
                  trialClass &&
                  trialClass.consultees &&
                  trialClass.consultees.length
                    ? getShortName(
                        trialClass.consultees[0].firstName,
                        trialClass.consultees[0].lastName
                      )
                    : '-'
                }
                descriptionProps={descriptionProps}
                avatarProps={{
                  src:
                    trialClass &&
                    trialClass.consultees &&
                    trialClass.consultees.length
                      ? trialClass.consultees[0].avatar
                      : '-',
                  alt:
                    trialClass &&
                    trialClass.consultees &&
                    trialClass.consultees.length
                      ? getShortName(
                          trialClass.consultees[0].firstName,
                          trialClass.consultees[0].lastName
                        )
                      : '-',
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Tutor Name"
                titleProps={titleProps}
                description={
                  trialClass.consultant
                    ? getShortName(
                        trialClass.consultant.firstName,
                        trialClass.consultant.lastName
                      )
                    : '-'
                }
                descriptionProps={descriptionProps}
                avatarProps={{
                  src:
                    trialClass &&
                    trialClass.consultant &&
                    trialClass.consultant.avatar
                      ? trialClass.consultant.avatar
                      : '',
                  alt:
                    trialClass && trialClass.consultant
                      ? trialClass.consultant.firstName
                      : '',
                }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Date & Time"
                titleProps={titleProps}
                description={
                  trialClass.startDate
                    ? moment(trialClass.startDate).format('DD MMM YYYY hh:mm A')
                    : '-'
                }
                descriptionProps={descriptionProps}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Subject"
                titleProps={titleProps}
                description={trialClass.subject || '-'}
                descriptionProps={descriptionProps}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Curriculum"
                titleProps={titleProps}
                description={trialClass.curriculum || '-'}
                descriptionProps={descriptionProps}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <DetailViewCard
                title="Grade"
                titleProps={titleProps}
                description={trialClass.grade || '-'}
                descriptionProps={descriptionProps}
              />
            </Grid>
          </Grid>
        </Box>
        {!_.isEmpty(trialClass) && (
          <Box
            style={{
              margin: '15px',
            }}
            sx={{
              borderRadius: '20px',
              display: { lg: 'none', xs: 'block' },
            }}
          >
            <CustomGrayContainer>
              <Typography fontSize="18px">
                {`${trialClass.curriculum || ''}, ${trialClass.subject || ''}`}
              </Typography>
              <Typography fontSize="18px">{trialClass.grade || ''}</Typography>
              <Typography fontSize="16px" fontWeight={600}>
                {`${tutorName} & ${studentName}`}
              </Typography>
              <Typography fontSize="12px" fontWeight={100}>
                {moment(trialClass.startDate).format('DD MMM YYYY hh:mm A')}
              </Typography>
            </CustomGrayContainer>
          </Box>
        )}
        <Box
          display="flex"
          justifyContent="center"
          bgcolor="black"
          margin={{ xs: '15px', sm: '5px 40px 0px 40px' }}
          borderRadius="20px"
          height="auto"
        >
          <Grid container spacing={0} direction="row" display="flex">
            <Grid
              item
              xs={12}
              lg={8}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              {currentVideo && currentVideo.type === 'MP4' && (
                <video
                  width="100%"
                  height="100%"
                  style={{ borderRadius: '20px' }}
                  controls
                  key={mediaKey}
                >
                  <source src={currentVideo.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              {currentVideo && currentVideo.type === 'M4A' && (
                <div style={{ padding: '30px 0' }}>
                  <audio
                    controls
                    key={mediaKey}
                    style={{ borderRadius: '20px' }}
                  >
                    <source src={currentVideo.url} type="audio/mp4" />
                    Your browser does not support the audio tag.
                  </audio>
                </div>
              )}
            </Grid>
            <Box
              sx={{
                display: { lg: 'none', xs: 'block' },
                width: '100%',
                padding: '10px',
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <Grid container alignItems="center" spacing={1}>
                    <Grid item>
                      <IconButton
                        onClick={() => setListExpanded(!isListExpanded)}
                      >
                        <PlaylistPlayIcon sx={{ color: 'white' }} />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <Typography color="white">Playlist</Typography>
                    </Grid>
                  </Grid>
                  <IconButton onClick={() => setListExpanded(!isListExpanded)}>
                    <ExpandMoreIcon
                      sx={{ color: 'white' }}
                      style={{
                        transform: !isListExpanded
                          ? 'rotate(0deg)'
                          : 'rotate(180deg)',
                        transition: 'transform 0.3s',
                      }}
                    />
                  </IconButton>
                </Box>
              </Grid>
            </Box>
            <Grid item xs={12} lg={4}>
              <Box sx={{ display: { lg: 'block', xs: 'none' } }}>
                {PLAY_LIST()}
              </Box>
              <Collapse
                in={isListExpanded}
                sx={{ display: { xs: 'block', lg: 'none' } }}
              >
                {PLAY_LIST()}
              </Collapse>
            </Grid>
          </Grid>
        </Box>
        {_feedback && (
          <Grid
            container
            spacing={2}
            sx={{ padding: { xs: '15px', sm: '40px' } }}
          >
            <Grid item xs={12} md={6}>
              <Box style={{ width: '100%' }}>
                <Typography fontSize="24px" fontWeight={800}>
                  Insights from your tutor
                </Typography>
                <Typography
                  align="justify"
                  fontSize="15px"
                  color="gray"
                  lineHeight="20px"
                >
                  Your learning journey matters to us! In this section, youll
                  find valueble feedback from your dedicated tutor of your trial
                  class. Discover what areas you excelled in and where you can
                  improve to make the most out of your {getAppName()}{' '}
                  experience. Our tutors are committed to helping you achieve
                  your learning goals, and this feedback is designed to support
                  your growth and success
                </Typography>
                <img
                  src={`${process.env.PUBLIC_URL}/images/thumbnails/recordings1.png`}
                  alt="test"
                  style={{ width: '100%' }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} overflow="auto">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box className={classes.formGroup}>
                    <Typography
                      className={classes.label}
                      style={{ margin: '0 0 10px 0' }}
                    >
                      Overall Rating for Student
                    </Typography>
                    <Rating
                      disabled
                      size="large"
                      value={_feedback.overallStudentRating}
                    />
                    {_feedback.feedbackRewards && (
                      <Grid
                        container
                        spacing={2}
                        className={classes.tagContainer}
                      >
                        {_feedback.feedbackRewards.map(
                          (feedbackReward, index) => (
                            <Grid
                              key={index}
                              item
                              xs={12}
                              style={{ padding: '0' }}
                            >
                              <Chip
                                label={feedbackReward}
                                className={classes.tag}
                              />
                            </Grid>
                          )
                        )}
                      </Grid>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.formGroup}>
                    <Typography
                      className={classes.label}
                      style={{ margin: '0 0 10px 0' }}
                    >
                      Student Attentiveness
                    </Typography>
                    <Chip
                      label={_feedback.studentAttentiveness || '-'}
                      className={classes.tag}
                      style={{ marginTop: '0' }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.formGroup}>
                    <Typography
                      className={classes.label}
                      style={{ margin: '0 0 10px 0' }}
                    >
                      Grasping and Application of concepts taught
                    </Typography>
                    <Chip
                      label={
                        _feedback.graspingAndApplicationOfConceptTaught || '-'
                      }
                      className={classes.tag}
                      style={{ marginTop: '0' }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.formGroup}>
                    <Typography
                      className={classes.label}
                      style={{ margin: '0 0 10px 0' }}
                    >
                      Detailed Feedback
                    </Typography>
                    <Chip
                      label={_feedback.comments || '-'}
                      className={classes.tag}
                      style={{ marginTop: '0' }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default TrialClassRecordings;
